import React, { Component } from "react"
import PropTypes from "prop-types"

export default class Clear extends Component {

  onClick =() => {
    let { specActions, path, method, parameters } = this.props

    const pathMethod = [path, method];

    specActions.clearResponse( path, method )
    specActions.clearRequest( path, method )

    /**
     * clear fields in the block with Parameters
     * @parameters  array
     * @changeParamByIdentity (pathMethod, rowParams, value, isXml)
     */
    if (parameters.size > 0) {
      parameters.forEach(rowParams => {
        specActions.changeParamByIdentity(pathMethod, rowParams, '', '' );
      })
    }
  }

  render(){
    return (
      <button className="btn btn-clear opblock-control__btn" onClick={ this.onClick }>
        Clear
      </button>
    )
  }

  static propTypes = {
    specActions: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
  }
}
